export interface GetSchedulesRequest {
  jobsiteCode?: string;
  dateTimeFrom?: string;
  dateTimeTo?: string;
  pointOfDeliveryCode?: string;
  plantCode?: string;
  productLineCode?: string;
  orderBy?: string;
}
